// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, " [data-v-3ff48e08-host] .toggle,:host .toggle {\n  font-size: 1rem;\n  font-weight: var(--magic-font-weight-semibold, 600);\n  margin-bottom: var(--magic-space--small, 8px);\n}\n [data-v-3ff48e08-host] .toggle--wide,:host .toggle--wide {\n  margin-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
